import { FormInput, NAMESPACE } from '@ui-kit'
import { FieldValues, useFormContext } from 'react-hook-form'
import { DEARenderPropTypes } from '../../types/common'
import { validateDea } from '@app-store'
import { useState } from 'react'

const DEARender = <T extends FieldValues>({
  name,
  label,
  disabled = false,
  placeholder = '',
  register,
  errors,
  validation,
  clearErrors: _clearErrors,
  depFieldkeyName,
  ...rest
}: DEARenderPropTypes<T>) => {
  const [validating, setValidating] = useState<boolean>(false)
  const { getValues } = useFormContext()

  return (
    <div className="flex items-center">
      <FormInput
        name={name}
        label={label}
        disabled={disabled}
        errors={errors}
        placeholder={placeholder}
        register={register}
        validation={{
          ...validation,
          validate: {
            thirdParty: async (fieldValue) => {
              try {
                setValidating(true)
                if (!fieldValue) return
                const res = await validateDea(
                  fieldValue ?? '',
                  getValues(depFieldkeyName ?? '')?.toUpperCase() ?? ''
                )
                return (
                  (res && res?.data?.Scenario === 'Valid') ||
                  NAMESPACE.INVALID_DEA
                )
              } catch {
                return NAMESPACE.INVALID_DEA
              } finally {
                setValidating(false)
              }
            },
          },
        }}
        {...rest}
      />
      {validating && (
        <div className="ml-2">
          <output
            className="animate-spin inline-block size-5 border-[3px] border-current border-t-transparent text-secondary-500 rounded-full dark:text-secondary-500"
            aria-label="loading"
          ></output>
        </div>
      )}
    </div>
  )
}

export default DEARender
